<template>
  <div class="flex ml-auto">
    <nuxt-link :to="prevProject" :title="$t('prev_project')">
      <v-icon name="chevron-left"></v-icon
    ></nuxt-link>
    <nuxt-link :to="nextProject" :title="$t('next_project')">
      <v-icon name="chevron-right"></v-icon
    ></nuxt-link>
  </div>
</template>

<script>
export default {
  props: {
    // projects
  },
  data() {
    return {
      prevProject: '',
      nextProject: ''
    }
  },

  mounted() {
    console.log('path: ', this.$route.path)

    let category = this.$route.path.split('/')[1]
    const categoryFiles = { architecture: 'projects.json' }
    const slug = this.$route.params.slug
    // console.log('params', this.$route.params)
    if (!categoryFiles[category]) category = this.$route.path.split('/')[2]
    // console.log('category', category)
    const jsonPath = `/json/${categoryFiles[category]}`
    // console.log('slug', slug)
    // console.log(jsonPath)
    this.$axios.$get(jsonPath).then((res) => {
      const index = res.map((e) => e.slug).indexOf(slug)
      const indexPrev = index > 0 ? index - 1 : res.length - 1
      // console.log(res.length)
      const indexNext = index < res.length - 1 ? index + 1 : 0
      // console.log(indexNext)
      const prevProject = res[indexPrev].slug
      const nextProject = res[indexNext].slug
      const path = `${category}-slug`
      this.prevProject = this.localePath({
        name: path,
        params: { slug: prevProject }
      })
      this.nextProject = this.localePath({
        name: path,
        params: { slug: nextProject }
      })
    })
  }
}
</script>

<style scoped lang="postcss">
.icon {
  height: 25px;
  width: 25px;
  opacity: 0.67;
  transition: 0.5s;
  &:hover {
    opacity: 1;
    @apply text-blue-500;
  }
}
</style>
